import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Box, Button, TextField, Typography } from "@material-ui/core";
import styles from "./unsubscribe.module.css";
import toast from "react-hot-toast";
import UnSubscribeViaEmail from "../../services/setRequest/UnSubscribeViaEmail";
import {
  decrypt,
  encrypt,
  generateSecreteKey,
} from "../../services/encryptionDecryptionService";
import {
  encryptDecryptKey,
  TOAST_COMMON_ERROR,
} from "../../constants/Constants";

const UnsubscribeEmail = () => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const btnStyle = {
    backgroundColor: "#97291E",
    color: "white",
    "&:hover": {
      backgroundColor: "blue",
    },
    "&.Mui-disabled": {
      backgroundColor: "#C17971",
      color: "white",
    },
  };
  const handleUnsubscribe = async () => {
    if (!email) {
      setError("Email is required.");
      return;
    }
    setError("");
    setMessage("");
    try {
      let secret = generateSecreteKey(5);

      let payload = {
        email: email,
      };

      let encrypted = encrypt(payload, encryptDecryptKey);
      console.log(JSON.stringify(encrypted));

      let response = await UnSubscribeViaEmail(JSON.stringify(encrypted));

      // Assuming `response.data` is the encrypted message
      let decryptedData = decrypt(response.data.part1, encryptDecryptKey);

      console.log("Un Subscribe", decryptedData);
      if (decryptedData.status === "success") {
        toast.success("EmailId unsubscribed ");
        setEmail("");
      } else {
        toast.error(TOAST_COMMON_ERROR);
      }
    } catch (error) {
      setError("Failed to unsubscribe. Please try again.");
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        padding: "2rem",
      }}>
      <Typography variant="h4" fontWeight="bold" textAlign="center">
        Unsubscribe
      </Typography>
      <Typography
        variant="body1"
        textAlign="center"
        sx={{ mt: 2, maxWidth: "400px" }}>
        We are sorry to see you go. Please confirm the email address below you
        would like to unsubscribe.
      </Typography>
      <Box sx={{ width: "100%", maxWidth: "400px", mt: 3 }}>
        <Typography variant="subtitle1" fontWeight="bold">
          Email
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={Boolean(error)}
          helperText={error}
          sx={{ mt: 1 }}
        />
      </Box>
      <button className={styles.unsubscribeBtn} onClick={handleUnsubscribe}>
        Unsubscribe
      </button>
      {message && (
        <Typography variant="body1" color="green" sx={{ mt: 2 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default UnsubscribeEmail;
